<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <label class="form-label fw-medium text-black"
              >Chercher Colis</label
            >
            <AutocompleteVue
              :search="search"
              :get-result-value="(result) => result.code"
              placeholder="Chercher Colis"
              @submit="handleSelect"
              @option-selected="handleSelect"
            >
              <template #result="{ result }">
                <span class="my-suggestion-item">{{ result.code }}</span>
              </template>
            </AutocompleteVue>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form class="row g-3" @submit.prevent="handleSubmit">
        <!-- Colis -->
        <div class="col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="colis"
            >Colis</label
          >
          <v-select
            class="custom-select-height"
            id="colis"
            label="text"
            v-model="OpenColi"
            :options="ColisList"
          />
        </div>

        <!-- Fragile 
        <div class="col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="fragile"
            >Fragile</label
          >
          <v-select
            class="custom-select-height"
            id="fragile"
            label="text"
            v-model="fragile"
            :options="FragileColis"
          />
          <small v-if="fragile.value == 1 && FragileFees != null">
            <b
              >Frais pour colis fragile : {{ FragileFees.fees }}
              {{ FragileFees.devis }}</b
            >
          </small>
        </div>-->

        <!-- Radios Replace -->
        <div class="col-md-6 form-group mb-3">
          <b-form-radio
            v-model="ReplaceColis"
            :value="0"
            class="custom-control-success"
            size="md"
          >
            Colis Simple
          </b-form-radio>
        </div>

        <div class="col-md-6 form-group mb-3">
          <b-form-radio
            v-model="ReplaceColis"
            :value="1"
            class="custom-control-success"
            size="md"
          >
            Colis Change
            <span :style="[ReplaceColis == 1 ? { 'font-size': '12px' } : '']">
              <br />
              Le colis sera remplacé avec le colis :
            </span>
          </b-form-radio>
          <div v-if="ReplaceColis == 1">
            <input
              class="form-control"
              placeholder="Code de suivi"
              v-model="form.code_replace"
              @change="searchColis"
            />
            <small class="text-danger" v-if="existcolis"
              >Ce colis n'existe pas</small
            >
            <small class="text-danger" v-if="replacecolis"
              >Vous ne pouvez pas remplacer ce colis</small
            >
          </div>
        </div>

    
        <div class="col-12"><hr /></div>

        <!-- Client -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="customer"
            >Client</label
          >
          <v-select
            class="custom-select-height"
            required
            id="customer"
            label="name"
            v-model="customer"
            placeholder="Client"
            :options="customerList"
          />
            <!-- @input="getFragileFees()" -->

        </div>

        <!-- Code suivi -->
        <div class="col-md-4 form-group mb-3">
          <label class="form-label fw-medium text-black" for="code"
            >Code de suivi</label
          >
          <input
            id="code"
            v-model="form.code"
            @change="verifiedCode"
            placeholder="Code de suivi"
            class="form-control"
          />
          <small class="text-danger" v-if="codeerror"
            >Ce code existe déjà</small
          >
        </div>

        <!-- Destinataire -->
        <div class="col-md-4 form-group mb-3">
          <label class="form-label fw-medium text-black" for="dest"
            >Destinataire</label
          >
          <input
            id="dest"
            v-model="form.receiver"
            placeholder="Destinataire"
            class="form-control"
          />
        </div>

        <!-- Téléphone -->
        <div class="col-md-4 form-group mb-3">
          <label class="form-label fw-medium text-black" for="phone"
            >Numéro de téléphone *</label
          >

          <input
            id="phone"
            v-model="form.phone"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            @change="blackList(form.phone)"
            placeholder="Numéro de téléphone *"
            class="form-control"
          />

          <template v-if="error_blacklst.msg">
            <small class="text-danger" v-if="error_blacklst.msg == 'exist'">
              Ce numéro est dans la black liste (
              {{ error_blacklst.count }} fois)
            </small>
            <small class="text-success" v-if="error_blacklst.msg == 'not exist'"
              >Ce numéro est sûr</small
            >
          </template>
        </div>

        <!-- Ville -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="city"
            >Ville</label
          >
          <v-select
            class="custom-select-height"
            id="city"
            required
            label="name"
            v-model="city"
            :options="citiesList"
            placeholder="Ville"
            @update:modelValue="onCityChange"
          />
        </div>

        <!-- Quartier -->
        <!-- <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="quartier"
            >Quartier</label
          >
          <v-select
            class="custom-select-height"
            id="quartier"
            label="name"
            :disabled="!city.id"
            v-model="quartier"
            :options="quartierList"
            placeholder="Quartier"
          />
        </div> -->

        <!-- Adresse -->
        <div class="col-12 col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="adresse"
            >Adresse</label
          >

          <textarea
            id="adresse"
            rows="2"
            maxlength="90"
            v-model="form.address"
            placeholder="Adresse"
            class="form-control"
          ></textarea>
        </div>

        <!-- Commentaire -->
        <div class="col-12 col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="comment"
            >Commentaire</label
          >

          <textarea
            id="comment"
            v-model="form.note"
            rows="2"
            maxlength="55"
            placeholder="Commentaire"
            class="form-control"
          ></textarea>
        </div>

        <!-- Prix -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="price"
            >Prix</label
          >

          <input
            id="price"
            v-model="form.price"
            type="number"
            min="1"
            placeholder="Prix"
            class="form-control"
          />
        </div>

        <!-- Frais -->
        <div class="col-12">
          <div class="form-group mb-3">
            <label class="form-label fw-medium text-black"
              >Frais de livraison</label
            >
            <input
              id="fees_livred"
              v-model="fees_livred"
              :placeholder="fl + ' ' + $devis + ' (frais calculés)'"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="form-label fw-medium text-black"
              >Frais de retour</label
            >
            <input
              id="fees_returned"
              v-model="fees_returned"
              :placeholder="fr + ' ' + $devis + ' (frais calculés)'"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="form-label fw-medium text-black"
              >Frais de refusé</label
            >
            <input
              id="fees_refused"
              v-model="fees_refused"
              :placeholder="frf + ' ' + $devis + ' (frais calculés)'"
              class="form-control"
            />
          </div>
        </div>

        <!-- Agence -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="agency"
            >Agence</label
          >
          <v-select
            class="custom-select-height"
            id="agency"
            label="name"
            v-model="agency"
            :options="agencyList"
            placeholder="Agence"
            required
          />
        </div>

        <!-- Statut -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black">Statut</label>
          <b-row>
            <div
              class="col-md-6"
              v-for="(item, index) in statutList"
              :key="index"
            >
              <input
                required
                type="radio"
                class="radio-btn"
                :id="item.id"
                v-model="statut"
                :value="item"
              />
              <label class="form-label fw-medium text-black" :for="item.id">{{
                item.name
              }}</label>
            </div>
          </b-row>
        </div>

        <!-- Paiement si statut sélectionné -->
        <!-- <template v-if="statut.code">
          <div class="col-md-6">
            <label class="form-label fw-medium text-black" for="caisse">Caisse *</label>
            <v-select class="custom-select-height"
              id="caisse"
              :options="Caisses"
              v-model="caisse"
              label="name"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-medium text-black" for="paid_amount">Montant Payé</label>
            <input
              id="paid_amount"
              v-model="paid_amount"
              type="number"
              placeholder="Montant Payé"
            />
          </div>
        </template> -->

        <!-- Submit -->
        <div
          class="col-md-12 d-flex align-items-center justify-content-between mt-20"
        >
          <button
            v-if="auth.can('PARCELS') && auth.can('ADD_PARCEL')"
            type="submit"
            class="btn btn-success px-4 py-2"
            :disabled="codeerror == true"
          >
            Enregistrer
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm ms-2"
            ></span>
          </button>
          <button type="button" class="btn btn-link text-danger">
            Annuler
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useSanitize } from "@/composables/useSanitize";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import AutocompleteVue from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import router from "@/router";

export default {
  name: "NewColis",
  components: {
    AutocompleteVue,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const { sanitizeText } = useSanitize();

    const auth = useAuthStore();
    const user = auth.user;

    const colisOptions = ref([]);
    const customerList = ref([]);
    const agencyList = ref([]);
    const citiesList = ref([]);
    const quartierList = ref([]);
    const statutList = ref([]);

    const loading = ref(false);

    const customer = ref<{
      id?: number;
      name?: string;
      phone?: string;
      delivered_price?: string;
      refused_price?: string;
      returned_price?: string;
    }>({});
    const city = ref({ id: 0, name: "" });
    const agency = ref<{ id?: number; name?: string }>({});
    const quartier = ref({ id: 0, name: "" });

    const ColisList = [
      { value: 1, text: "Ouvrir le colis" },
      { value: 0, text: "Ne pas ouvrir le colis" },
    ];

    const OpenColi = ref({ value: 0, text: "Ne pas ouvrir le colis" });
    const FragileColis = [
      { value: 1, text: "Oui" },
      { value: 0, text: "Non" },
    ];
    const fragile = ref({ value: 0, text: "Non" });
    const error_blacklst = ref({ msg: "", count: "" });
    const statut = ref({ id: 0, name: null , code: null });

    const ReplaceColis = ref(0);
    const RplColis = ref("");
    const existcolis = ref(false);
    const replacecolis = ref(false);
    const FragileFees = ref(null);
    const codeerror = ref(false);

    const fl = ref("");
    const fr = ref("");
    const frf = ref("");

    const fees_livred = ref("");
    const fees_returned = ref("");
    const fees_refused = ref("");

    const form = reactive({
      id: 0,
      code: "",
      can_open: 1,
      fragile: 0,
      replace: 0,
      code_replace: "",
      partial_return: 0,
      partial_send: 0,
      receiver: "",
      phone: "",
      address: "",
      note: "",
      price: "",
    });

    // 🔹 Fonction pour reset le form
    function resetForm() {
      form.id = 0;
      form.code = "";
      form.can_open = 1;
      form.fragile = 0;
      form.replace = 0;
      form.code_replace = "";
      form.partial_return = 0;
      form.partial_send = 0;
      form.receiver = "";
      form.phone = "";
      form.address = "";
      form.note = "";
      form.price = "";
    }

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/Customers`);
        if (response && response.data) {
          customerList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const response = await api.get(`/api/auth/agency`);
        if (response && response.data) {
          agencyList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const response = await api.get(`/api/auth/citiesFees`);
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const response = await api.get(`/api/auth/status_coli_admin`);
        if (response && response.data) {
          statutList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    async function onInputChange(text) {
      if (!text) {
        return;
      }

      try {
        const res = await api.get(`/api/auth/SearchColis`, {
          params: { searchcolis: text },
        });

        if (res.data?.msg === "success") {
          colisOptions.value = res.data.data;
        }
      } catch (error) {
        console.error("Erreur lors de la recherche des colis :", error);
      }
    }

    async function getQuartier(city) {
      const res = await api.get(`/api/auth/QuartierList?city=${city.id}`);
      quartierList.value = res.data;
    }

    async function showFees(city) {
      if (!city?.id || !customer.value?.id) return; // safeguard

      try {
        const res = await api.get(
          `/api/auth/GetFeesLivred?city=${city.id}&customer=${customer.value.id}`
        );

        if (res.data) {
          fl.value = res.data.liv_fees ?? "";
          fr.value = res.data.refus_fees ?? "";
          frf.value = res.data.return_fees ?? "";
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des frais :", error);
        fl.value = "";
        fr.value = "";
        frf.value = "";

        // fl=city.delivered_fees
        // fr=city.retourned_fees
        // frf=city.refused_fees
      }
    }

    async function getFragileFees() {
      if (fragile.value.value == 1) {
        const res = await api.get(
          `/api/auth/FragileFeesCust?cust=${customer.value.id}`
        );

        if (res.data.msg == "success") {
          FragileFees.value = res.data.data;
        }
      }
    }

    // async function getSuggestionValue(suggestion) {
    //   suggestion.item.code = suggestion.item.code + "_2";

    //   customer.value = {
    //     id: suggestion.item.customer,
    //     name: suggestion.item.customer_name,
    //   };

    //   city.value = {
    //     id: suggestion.item.city_id,
    //     name: suggestion.item.city_name,
    //   };

    //   quartier.value = {
    //     id: suggestion.item.quartier_id,
    //     name: suggestion.item.quartier_name ?? "",
    //   };

    //   OpenColi.value = {
    //     value: suggestion.item.can_open,
    //     text: suggestion.item.can_open
    //       ? "Ouvrir le colis"
    //       : "Ne pas ouvrir le colis",
    //   };

    //   fragile.value = {
    //     value: suggestion.item.fragile,
    //     text: suggestion.item.fragile ? "Oui" : "Non",
    //   };

    //   if (suggestion.item.replace == 1) {
    //     ReplaceColis.value = 1;
    //   } else if (suggestion.item.partial == 1) {
    //     ReplaceColis.value = 2;
    //   } else {
    //     ReplaceColis.value = 0;
    //   }

    //   resetForm();
    //   Object.assign(form, suggestion.item); // copie toutes les propriétés
    //   form.phone = oldPhone(suggestion.item.phone); // formatage du téléphone

    //   try {
    //     const res = await api.get(
    //       `/api/auth/GetFeesLivred?city=${city.value.id}&customer=${customer.value.id}`
    //     );

    //     if (res.data) {
    //       fl.value = res.data.liv_fees;
    //       fr.value = res.data.refus_fees;
    //       frf.value = res.data.return_fees;
    //     }
    //   } catch (error) {
    //     console.error("Erreur lors de la récupération des frais :", error);
    //   }
    // }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }

    async function search(input) {
      if (input.length < 2) return [];

      try {
        const res = await api.get(`/api/auth/SearchColis?searchcolis=${input}`);
        return res.data.data ?? [];
      } catch (error) {
        console.error("Erreur lors de la recherche:", error);
        return [];
      }
    }

    async function handleSelect(suggestion) {
      console.log("sufes", suggestion);
      // Adjust code
      suggestion.item.code = suggestion.item.code + "_2";

      customer.value = {
        id: suggestion.item.customer,
        name: suggestion.item.customer_name,
      };

      city.value = {
        id: suggestion.item.city_id,
        name: suggestion.item.city_name,
      };

      quartier.value = {
        id: suggestion.item.quartier_id,
        name: suggestion.item.quartier_name ?? "",
      };

      OpenColi.value = {
        value: suggestion.item.can_open,
        text: suggestion.item.can_open
          ? "Ouvrir le colis"
          : "Ne pas ouvrir le colis",
      };

      fragile.value = {
        value: suggestion.item.fragile,
        text: suggestion.item.fragile ? "Oui" : "Non",
      };

      if (suggestion.item.replace == 1) {
        ReplaceColis.value = 1;
      } else if (suggestion.item.partial == 1) {
        ReplaceColis.value = 2;
      } else {
        ReplaceColis.value = 0;
      }

      resetForm();
      Object.assign(form, suggestion.item);
      form.phone = oldPhone(suggestion.item.phone);

      try {
        const res = await api.get(
          `/api/auth/GetFeesLivred?city=${city.value.id}&customer=${customer.value.id}`
        );

        if (res.data) {
          fl.value = res.data.liv_fees;
          fr.value = res.data.refus_fees;
          frf.value = res.data.return_fees;
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des frais :", error);
      }
    }

    async function searchColis() {
      existcolis.value = false;
      replacecolis.value = false;

      try {
        const data = new FormData();
        data.append("user_id", user?.id);
        data.append("codesuivi", form.code_replace);

        const res = await api.post(`/api/auth/ColisExist`, data);

        if (res.data === "not exist") {
          existcolis.value = true;
        } else if (res.data === "exist") {
          existcolis.value = false;
        } else if (res.data === "error status") {
          replacecolis.value = true;
        }
      } catch (error) {
        console.error("Erreur lors de la vérification du colis :", error);
      }
    }

    async function blackList(phone) {
      try {
        // reset values
        error_blacklst.value = { msg: "", count: "" };

        const res = await api.post(`/api/auth/checkBlackList?phone=${phone}`);

        error_blacklst.value.msg = res.data.msg;
        error_blacklst.value.count = res.data.count;
      } catch (error) {
        console.error(
          "Erreur lors de la vérification de la blacklist :",
          error
        );
      }
    }

    async function verifiedCode() {
      codeerror.value = false;

      if (form.code) {
        try {
          const data = new FormData();
          data.append("codesuivi", form.code);

          const res = await api.post(`/api/auth/search_code_colis`, data);

          if (res.data === "exist") {
            codeerror.value = true;
            showToast("Un colis avec ce code existe déjà", "error");
          } else {
            codeerror.value = false;
          }
        } catch (error) {
          console.error(
            "Erreur lors de la vérification du code colis :",
            error
          );
        }
      }
    }

    function onCityChange(selectedCity) {
      city.value = selectedCity; // update v-model (optional, Vue does this automatically)
      showFees(selectedCity);
      getQuartier(selectedCity);
    }

    // -------- Helper Functions --------
    const validateForm = () => {
      if (!customer.value?.id || !agency.value?.id || !city.value?.id)
        return false;
      if (!form.receiver || !form.phone || !form.address) return false;
      if (
        (form.address && form.address.length > 40) ||
        (form.note && form.note.length > 55)
      )
      // if (!form.price || form.price =='0' )  return false;
        return false;
      return true;
    };

    const buildFormData = () => {
      const data = new FormData();
      data.append("userID", user?.id ?? "");
      data.append("codesuivi", sanitizeText(form.code));
      data.append("adresse", sanitizeText(form.address));
      data.append("comment", sanitizeText(form.note));
      data.append("dest", sanitizeText(form.receiver));
      data.append("phone", sanitizeText(form.phone));
      data.append("fees_livred", fees_livred.value);
      data.append("fees_returned", fees_returned.value);
      data.append("fees_refused", fees_refused.value);
      data.append("city", city.value.name);
      data.append("city_id", String(city.value.id));
      // data.append("quartier_id", String(quartier.value.id));
      data.append("customer_id", String(customer.value.id));
      data.append("customer", customer.value.name);
      data.append("customer_p", customer.value.phone);
      data.append("price", form.price);
      data.append("agency_id", String(agency.value.id));
      data.append("agency", agency.value.name);
      data.append("statut", statut.value.code ?? "");
      data.append("statut_id", String(statut.value.id));
      data.append("c_delivered_price", customer.value.delivered_price ?? "");
      data.append("c_refused_price", customer.value.refused_price ?? "");
      data.append("c_returned_price", customer.value.returned_price ?? "");
      data.append("fragile", String(fragile.value.value));
      data.append("opencoli", String(OpenColi.value.value));
      data.append("canreplace", String(ReplaceColis.value));
      data.append("codereplace", sanitizeText(form.code_replace));
      data.append("partial_send", String(form.partial_send));
      data.append("partial_return", String(form.partial_return));
      return data;
    };

    // -------- Submit Function --------
    const handleSubmit = async () => {
      if (!validateForm()) {
        showToast("Merci de remplir tous les champs correctement", "error");
        return;
      }

      const data = buildFormData();

      loading.value = true;
      try {
        const res = await api.post("/api/auth/colis_add", data);

        switch (res.data.message) {
          case "success":
            showToast("Les données sont bien sauvegardées", "success");
            router.push("/new-colis-list");
            break;
          case "code exist":
            showToast("Un colis avec ce code existe déjà", "error");
            break;
          case "no customer":
            showToast("Ce client est supprimé ou désactivé", "error");
            break;
          default:
            showToast("Erreur lors de l'envoi", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue", "error");
      } finally {
        loading.value = false;
      }
    };

    return {
      auth,
      colisOptions,
      loading,
      onInputChange,
      form,
      search,
      handleSelect,

      OpenColi,
      ColisList,
      FragileColis,
      fragile,
      ReplaceColis,
      replacecolis,
      RplColis,
      existcolis,
      FragileFees,
      searchColis,
      quartier,
      city,
      agency,
      error_blacklst,
      fees_livred,
      fees_returned,
      fees_refused,

      fl,
      fr,
      frf,
      statut,
      codeerror,

      customer,
      customerList,
      agencyList,
      citiesList,
      quartierList,
      statutList,

      getQuartier,
      getFragileFees,
      showFees,
      blackList,
      verifiedCode,
      onCityChange,

      handleSubmit,
    };
  },
};
</script>
<style>
.my-suggestion-item {
  cursor: pointer;
}

.autocomplete-results {
  z-index: 9999; /* make sure it's above modals/forms */
}
</style>